import { render, staticRenderFns } from "./VideoTutorialsPage.vue?vue&type=template&id=4a0216f9"
import script from "./VideoTutorialsPage.vue?vue&type=script&lang=js"
export * from "./VideoTutorialsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports